import { render, staticRenderFns } from "./openIdKeycloak.vue?vue&type=template&id=9f8ce7ec"
import script from "./openIdKeycloak.vue?vue&type=script&lang=js"
export * from "./openIdKeycloak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports